/* loaded by smart-asset */
export default require("./assets/gray-tote.i.svg")